// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { AdminNumber } from './admin-number';
import { BankruptNumber } from './bankrupt-number';
import { ContactNumber } from './contact-number';
import { CounterpartyNumber } from './counterparty-number';
import { EmployeeNumber } from './employee-number';
import { NumberType } from './number-type';
import { PracticeNumber } from './practice-number';
import { ShareHolderNumber } from './share-holder-number';
import { UserNumber } from './user-number';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class Number extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  numberId!: number;
  createdBy!: string;
  createdDate!: Date;
  flags?: number;
  number1!: string;
  numberTypeId!: number;
  ts!: string;
  updatedBy!: string;
  updatedDate!: Date;
  adminNumbers!: AdminNumber[];
  bankruptNumbers!: BankruptNumber[];
  contactNumbers!: ContactNumber[];
  counterpartyNumbers!: CounterpartyNumber[];
  employeeNumbers!: EmployeeNumber[];
  numberType!: NumberType;
  practiceNumbers!: PracticeNumber[];
  shareHolderNumbers!: ShareHolderNumber[];
  userNumbers!: UserNumber[];
}

